/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDto } from './ContactDto';
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
    ContactDtoToJSONTyped,
} from './ContactDto';

/**
 * 
 * @export
 * @interface UpdateSpecialConditionsCommand
 */
export interface UpdateSpecialConditionsCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    borrowerProjectId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    quoteId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    bankAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    frequencyId: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateSpecialConditionsCommand
     */
    startDate: Date;
    /**
     * Code of the selected insurance project type (e.g. RENEG_BANQUE, RENEG_COURTIER, or other project codes)
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    insuranceProjectCode: string;
    /**
     * Existing outstanding amount (excluding this project), in euros
     * @type {number}
     * @memberof UpdateSpecialConditionsCommand
     */
    existingOutstanding: number;
    /**
     * Existing outstanding amount from current insurer (excluding this project), in euros
     * @type {number}
     * @memberof UpdateSpecialConditionsCommand
     */
    existingOutstandingInsurer: number;
    /**
     * Current loan number
     * @type {string}
     * @memberof UpdateSpecialConditionsCommand
     */
    currentLoanNumber?: string;
    /**
     * 
     * @type {ContactDto}
     * @memberof UpdateSpecialConditionsCommand
     */
    bankContact: ContactDto;
    /**
     * 
     * @type {ContactDto}
     * @memberof UpdateSpecialConditionsCommand
     */
    insuranceContact?: ContactDto;
}

/**
 * Check if a given object implements the UpdateSpecialConditionsCommand interface.
 */
export function instanceOfUpdateSpecialConditionsCommand(value: object): value is UpdateSpecialConditionsCommand {
    if (!('borrowerProjectId' in value) || value['borrowerProjectId'] === undefined) return false;
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('bankAccountId' in value) || value['bankAccountId'] === undefined) return false;
    if (!('frequencyId' in value) || value['frequencyId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('insuranceProjectCode' in value) || value['insuranceProjectCode'] === undefined) return false;
    if (!('existingOutstanding' in value) || value['existingOutstanding'] === undefined) return false;
    if (!('existingOutstandingInsurer' in value) || value['existingOutstandingInsurer'] === undefined) return false;
    if (!('bankContact' in value) || value['bankContact'] === undefined) return false;
    return true;
}

export function UpdateSpecialConditionsCommandFromJSON(json: any): UpdateSpecialConditionsCommand {
    return UpdateSpecialConditionsCommandFromJSONTyped(json, false);
}

export function UpdateSpecialConditionsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSpecialConditionsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerProjectId': json['borrowerProjectId'],
        'quoteId': json['quoteId'],
        'bankAccountId': json['bankAccountId'],
        'frequencyId': json['frequencyId'],
        'startDate': (new Date(json['startDate'])),
        'insuranceProjectCode': json['insuranceProjectCode'],
        'existingOutstanding': json['existingOutstanding'],
        'existingOutstandingInsurer': json['existingOutstandingInsurer'],
        'currentLoanNumber': json['currentLoanNumber'] == null ? undefined : json['currentLoanNumber'],
        'bankContact': ContactDtoFromJSON(json['bankContact']),
        'insuranceContact': json['insuranceContact'] == null ? undefined : ContactDtoFromJSON(json['insuranceContact']),
    };
}

export function UpdateSpecialConditionsCommandToJSON(json: any): UpdateSpecialConditionsCommand {
    return UpdateSpecialConditionsCommandToJSONTyped(json, false);
}

export function UpdateSpecialConditionsCommandToJSONTyped(value?: UpdateSpecialConditionsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerProjectId': value['borrowerProjectId'],
        'quoteId': value['quoteId'],
        'bankAccountId': value['bankAccountId'],
        'frequencyId': value['frequencyId'],
        'startDate': ((value['startDate']).toISOString()),
        'insuranceProjectCode': value['insuranceProjectCode'],
        'existingOutstanding': value['existingOutstanding'],
        'existingOutstandingInsurer': value['existingOutstandingInsurer'],
        'currentLoanNumber': value['currentLoanNumber'],
        'bankContact': ContactDtoToJSON(value['bankContact']),
        'insuranceContact': ContactDtoToJSON(value['insuranceContact']),
    };
}

